import { 
    Trophy, Star, Medal, Lightning, Target, Crown,
    Car, RocketLaunch, Flag, Certificate
} from '@phosphor-icons/react';

/**
 * Single source of truth for achievement badges.
 * Each badge has a stable `id`, display data, and a `check(data)` predicate.
 * `data` is `{ skills, scores, lessonCount }`.
 */
export const BADGE_DEFINITIONS = [
    {
        id: 'first_lesson',
        name: 'Eerste Les',
        description: 'Je eerste rijles gehad!',
        icon: Car,
        color: '#D4A537',
        check: (data) => data.lessonCount >= 1,
    },
    {
        id: 'five_lessons',
        name: '5 Lessen',
        description: '5 rijlessen voltooid',
        icon: Star,
        color: '#D4A537',
        check: (data) => data.lessonCount >= 5,
    },
    {
        id: 'ten_lessons',
        name: '10 Lessen',
        description: '10 rijlessen voltooid',
        icon: Medal,
        color: '#D4A537',
        check: (data) => data.lessonCount >= 10,
    },
    {
        id: 'twenty_lessons',
        name: '20 Lessen',
        description: '20 rijlessen voltooid',
        icon: Trophy,
        color: '#D4A537',
        check: (data) => data.lessonCount >= 20,
    },
    {
        id: 'bediening_master',
        name: 'Voertuig Meester',
        description: 'Alle Bediening Voertuig op groen!',
        icon: Lightning,
        color: '#38A169',
        check: (data) => {
            const bedieningSkills = (data.skills || []).filter(s => s.category === 'bediening_voertuig');
            return bedieningSkills.length > 0 && bedieningSkills.every(s => (data.scores[s.id] || 0) >= 4);
        },
    },
    {
        id: 'verkeer_master',
        name: 'Verkeersheld',
        description: 'Alle Verkeersdeelneming op groen!',
        icon: Target,
        color: '#38A169',
        check: (data) => {
            const verkeerSkills = (data.skills || []).filter(s => s.category === 'verkeersdeelneming');
            return verkeerSkills.length > 0 && verkeerSkills.every(s => (data.scores[s.id] || 0) >= 4);
        },
    },
    {
        id: 'verrichtingen_master',
        name: 'Manoeuvre Expert',
        description: 'Alle Bijzondere Verrichtingen op groen!',
        icon: Flag,
        color: '#38A169',
        check: (data) => {
            const verrichtingSkills = (data.skills || []).filter(s => s.category === 'bijzondere_verrichtingen');
            return verrichtingSkills.length > 0 && verrichtingSkills.every(s => (data.scores[s.id] || 0) >= 4);
        },
    },
    {
        id: 'halfway',
        name: 'Halverwege',
        description: '50% van alle vaardigheden beheerst',
        icon: RocketLaunch,
        color: '#D4A537',
        check: (data) => {
            const scores = Object.values(data.scores || {});
            const mastered = scores.filter(s => s >= 4).length;
            return (data.skills || []).length > 0 && (mastered / data.skills.length) >= 0.5;
        },
    },
    {
        id: 'exam_ready',
        name: 'Klaar voor Examen!',
        description: 'Alle 26 vaardigheden op groen!',
        icon: Crown,
        color: '#D4A537',
        check: (data) => {
            return (data.skills || []).length > 0 && data.skills.every(s => (data.scores[s.id] || 0) >= 4);
        },
    },
    {
        id: 'perfect_score',
        name: 'Perfect!',
        description: 'Alle vaardigheden een 5!',
        icon: Certificate,
        color: '#D4A537',
        check: (data) => {
            return (data.skills || []).length > 0 && data.skills.every(s => (data.scores[s.id] || 0) === 5);
        },
    },
];

/** Compute which badge ids are currently earned for a given dataset. */
export function computeEarnedBadgeIds({ skills, scores, lessonCount }) {
    const data = { skills, scores, lessonCount };
    return BADGE_DEFINITIONS.filter(b => b.check(data)).map(b => b.id);
}
